import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import {Helmet} from 'react-helmet';
import HttpsRedirect from 'react-https-redirect';

import {Header} from "./components/Header.js";
import {Footer} from "./components/Footer.js";

import {Main} from "./page/Main.js";

import './App.css';

class App extends Component {

  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <HttpsRedirect>
            <Helmet>
              <title>rewardeclub | Customers eclub, done.</title>
              <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
              <meta name="description" content="rewardeclub connects businesses and its customers by managing customer's eclub." />
              <meta name="keywords" content="eclub, e-club, customer eclub, customer e-club, customers eclub, customers e-club, manage eclub, eclub management, manage e-club, e-club management, connect business and customers" />
              <meta name="robots" content="index, follow" />
            </Helmet>
            <Header data="main" overlay="menu-overlay"/>
            <Main />
            <Footer />
          </HttpsRedirect>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js